import axiosClient from "./axiosClient";
import axiosMultipartClient from "./axiosMultipartClient";
import { Resume } from "lib/redux/types";
import { toast } from "react-toastify";
import axiosOpenClient from "./axiosOpenClient";
import axios from "axios";

// Fetch all resumes for the user
export const getAllResumes = async (): Promise<Resume[]> => {
  try {
    const response = await axiosClient.get("/api/resumes");
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createResume = async (
  resumeData: Partial<Resume>,
  // file?: File
  userProfilePhoto?: string
) => {
  try {
    const formData = new FormData();
    formData.append(
      "resume",
      new Blob([JSON.stringify(resumeData)], { type: "application/json" })
    );
    const file = new File([userProfilePhoto as BlobPart], "profile-pic.png", {
      type: "image/png",
    });
    if (file) {
      formData.append("file", file); // Adding optional file
    }
    const response = await axiosMultipartClient.post("/api/resumes", formData);
    toast.success("Resume Created Successfully");
    return response.data;
  } catch (error: any) {
    if (error.code !== "TOKEN_EXPIRED") {
      toast.error("Error Saving Resume");
    }
    throw error;
  }
};

export const updateResume = async (
  resumeData: Partial<Resume>,
  resumeId: number,
  // file?: File
  userProfilePhoto?: string
) => {
  try {
    const formData = new FormData();
    formData.append(
      "resume",
      new Blob([JSON.stringify(resumeData)], { type: "application/json" })
    );
    // const newFile = localStorage.getItem("profile-pic");
    // convert this newFile which is saved as string to a file
    // const actualFile = new File([newFile as BlobPart], "profile-pic.png", {
    //   type: "image/png",
    // });
    const file = new File([userProfilePhoto as BlobPart], "profile-pic.png", {
      type: "image/png",
    });
    if (file) {
      // console.log("file", actualFile);
      formData.append("file", file); // Adding optional file
    }
    const response = await axiosMultipartClient.put(
      `/api/resumes/${resumeId}`,
      formData
    );
    toast.success("Resume Updated Successfully");
    return response.data;
  } catch (error: any) {
    if (axios.isAxiosError(error) && error.response?.status === 404) {
      throw error;
    }
    if (error.code !== "TOKEN_EXPIRED") {
      toast.error("Error Saving Resume");
    }
    throw error;
  }
};

// Delete a resume
export const deleteResume = async (resumeId: number) => {
  try {
    const response = await axiosClient.delete(`/api/resumes/${resumeId}`);
    toast.success("Resume Deleted Successfully");
    return response.data;
  } catch (error) {
    toast.error("Error Deleting Resume");
    console.log("Error Deleting Resume", error);
  }
};

interface visiblityProps {
  displayName?: string;
  published?: boolean;
}

// Change Resume Visibility
export const changeResumeVisibility = async (
  resumeId: number,
  resumeData: visiblityProps
) => {
  try {
    const response = await axiosClient.patch(`/api/resumes/${resumeId}`, {
      displayName: resumeData.displayName || "",
      published: resumeData.published || false,
    });
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

interface publicResumeViewProps {
  ua: string;
  ip: string;
  screenSize: string;
  sessionId: string;
  deviceId: string;
}

// Get Public Resume View
export const getPublicResumeView = async (
  resumeId: number,
  publicResumeViewData: publicResumeViewProps
) => {
  try {
    const response = await axiosOpenClient.post(
      `public/api/resumes/${resumeId}`,
      publicResumeViewData
    );
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

// Send Public Resume View Updates
interface viewUpdateDataProps {
  sessionId: string;
  duration: number;
  isDownloaded?: boolean;
}
interface publicResumeViewUpdateProps {
  resumeId: number;
  viewUpdateData: viewUpdateDataProps;
}

export const sendPublicResumeViewUpdate = async ({
  resumeId,
  viewUpdateData,
}: publicResumeViewUpdateProps) => {
  try {
    const response = await axiosOpenClient.patch(
      `public/api/resumes/${resumeId}`,
      viewUpdateData
    );
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

// Get All Resume Stats

export const getResumeStats = async (topk: number) => {
  try {
    const response = await axiosClient.get(`/api/resumes/stats?topK=${topk}`);
    return response.data;
  } catch (error) {
    console.log(error);
    // throw error;
  }
};

export const sendDownloadedResume = async (payLoad: any) => {
  try {
    const response = await axiosOpenClient.post(
      `public/api/resumes/downloaded-resumes`,
      payLoad
    );
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
